import { render, staticRenderFns } from "./ConfirmBox.vue?vue&type=template&id=dcf1db78&scoped=true"
import script from "./ConfirmBox.vue?vue&type=script&lang=js"
export * from "./ConfirmBox.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBox.vue?vue&type=style&index=0&id=dcf1db78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf1db78",
  null
  
)

export default component.exports